import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
const platforms = ['TikTok Shop', 'Shopify', 'Amazon', 'Meta Ads', 'WooCommerce', 'PayPal', 'Etsy', 'eBay'];
const testimonials = [{
  initials: 'MR',
  avatarBg: '#18a39f',
  avatarColor: 'white',
  name: 'María Rodríguez',
  location: 'Miami, FL',
  quote: 'Apliqué el sistema desde el primer módulo y logré resultados consistentes en pocas semanas. El método de José es claro, estructurado y fácil de implementar.',
  badge: 'Resultados Consistentes',
  badgeBg: 'rgba(24,163,159,0.15)',
  badgeColor: 'var(--color-teal)',
  badgeBorder: 'rgba(24,163,159,0.35)'
}, {
  initials: 'CL',
  avatarBg: '#f22a72',
  avatarColor: 'white',
  name: 'Carlos López',
  location: 'Ciudad de México',
  quote: 'Construí un activo digital sostenible en TikTok Shop siguiendo el sistema paso a paso. La comunidad y el soporte son excepcionales.',
  badge: 'Activo Digital Activo',
  badgeBg: 'rgba(242,42,114,0.12)',
  badgeColor: 'var(--color-pink)',
  badgeBorder: 'rgba(242,42,114,0.3)'
}, {
  initials: 'AP',
  avatarBg: '#ffe222',
  avatarColor: '#0a0a0f',
  name: 'Ana Pérez',
  location: 'Bogotá, Colombia',
  quote: 'Sin experiencia previa en eCommerce, logré dominar las habilidades del programa y construir un negocio digital profesional desde cero.',
  badge: 'Crecimiento Profesional',
  badgeBg: 'rgba(255,226,34,0.12)',
  badgeColor: 'var(--color-yellow)',
  badgeBorder: 'rgba(255,226,34,0.3)'
}];
export function SocialProof() {
  const doubled = [...platforms, ...platforms];
  return <section style={{
    background: 'var(--bg-secondary)',
    padding: '56px 0',
    overflow: 'hidden'
  }} data-id="element-75">
      {/* Part 1: Scrolling logos */}
      <div style={{
      marginBottom: '48px'
    }} data-id="element-76">
        <motion.p initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} style={{
        textAlign: 'center',
        color: '#6b6b80',
        fontSize: '13px',
        fontFamily: 'Inter, sans-serif',
        letterSpacing: '0.1em',
        textTransform: 'uppercase',
        marginBottom: '28px',
        padding: '0 24px'
      }} data-id="element-77">
          Plataformas donde nuestros estudiantes venden
        </motion.p>

        <div className="marquee-container" style={{
        overflow: 'hidden'
      }} data-id="element-78">
          <div className="marquee-track" data-id="element-79">
            {doubled.map((platform, i) => <div key={`${platform}-${i}`} style={{
            flexShrink: 0,
            margin: '0 10px',
            background: 'rgba(255,255,255,0.04)',
            backdropFilter: 'blur(12px)',
            border: '1px solid rgba(255,255,255,0.08)',
            borderRadius: '100px',
            padding: '10px 22px',
            color: '#a0a0b0',
            fontSize: '13px',
            fontWeight: 600,
            fontFamily: 'Inter, sans-serif',
            whiteSpace: 'nowrap'
          }} data-id="element-80">
                {platform}
              </div>)}
          </div>
        </div>
      </div>

      {/* Part 2: Testimonials */}
      <div style={{
      maxWidth: '1100px',
      margin: '0 auto',
      padding: '0 16px'
    }} data-id="element-81">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} style={{
        textAlign: 'center',
        marginBottom: '32px'
      }} data-id="element-82">
          <h2 style={{
          fontFamily: 'Poppins, sans-serif',
          fontWeight: 900,
          fontSize: 'clamp(24px, 3.5vw, 40px)',
          color: 'white',
          marginBottom: '10px',
          letterSpacing: '-0.02em'
        }} data-id="element-83">
            Resultados Profesionales de Estudiantes Reales
          </h2>
          <p style={{
          color: '#a0a0b0',
          fontSize: '16px',
          fontFamily: 'Inter, sans-serif'
        }} data-id="element-84">
            Personas como tú que aplicaron el sistema y construyeron negocios
            digitales sostenibles
          </p>
        </motion.div>

        <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)',
        gap: '20px'
      }} className="testimonials-grid" data-id="element-85">
          {testimonials.map((t, i) => <motion.div key={t.name} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.12
        }} className="speech-bubble" style={{
          background: 'rgba(255,255,255,0.04)',
          backdropFilter: 'blur(20px)',
          border: '1px solid rgba(24,163,159,0.12)',
          borderRadius: '20px',
          padding: '24px',
          position: 'relative'
        }} data-id="element-86">
              {/* Stars */}
              <div style={{
            display: 'flex',
            gap: '3px',
            marginBottom: '14px'
          }} data-id="element-87">
                {[1, 2, 3, 4, 5].map(s => <StarIcon key={s} size={14} color="var(--color-yellow)" fill="var(--color-yellow)" data-id="element-88" />)}
              </div>

              {/* Quote */}
              <p style={{
            color: '#d0d0e0',
            fontSize: '14px',
            fontFamily: 'Inter, sans-serif',
            lineHeight: 1.7,
            marginBottom: '20px',
            fontStyle: 'italic'
          }} data-id="element-89">
                "{t.quote}"
              </p>

              {/* Avatar + name + badge */}
              <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: '10px'
          }} data-id="element-90">
                <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '10px'
            }} data-id="element-91">
                  <div style={{
                width: '40px',
                height: '40px',
                borderRadius: '50%',
                background: t.avatarBg,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontFamily: 'Poppins, sans-serif',
                fontWeight: 900,
                fontSize: '13px',
                color: t.avatarColor,
                flexShrink: 0
              }} data-id="element-92">
                    {t.initials}
                  </div>
                  <div data-id="element-93">
                    <div style={{
                  color: 'white',
                  fontWeight: 700,
                  fontSize: '13px',
                  fontFamily: 'Poppins, sans-serif'
                }} data-id="element-94">
                      {t.name}
                    </div>
                    <div style={{
                  color: '#6b6b80',
                  fontSize: '11px',
                  fontFamily: 'Inter, sans-serif'
                }} data-id="element-95">
                      {t.location}
                    </div>
                  </div>
                </div>
                <div style={{
              background: t.badgeBg,
              border: `1px solid ${t.badgeBorder}`,
              borderRadius: '100px',
              padding: '4px 10px',
              color: t.badgeColor,
              fontSize: '11px',
              fontWeight: 700,
              fontFamily: 'Inter, sans-serif',
              whiteSpace: 'nowrap',
              flexShrink: 0
            }} data-id="element-96">
                  {t.badge}
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>

      <style data-id="element-97">{`
        @media (max-width: 768px) {
          .testimonials-grid {
            grid-template-columns: 1fr !important;
          }
        }
      `}</style>
    </section>;
}